import React from "react";

import "./index.less";

type ErrorBoundaryState = {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
  copied: boolean;
};

export class ErrorBoundary extends React.Component<React.PropsWithChildren, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    error: null,
    errorInfo: null,
    copied: false,
  };

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({ error, errorInfo, copied: false });
  }

  handleCopy = () => {
    const { error, errorInfo } = this.state;
    if (!error) return;
    const text = `Error: ${error.message}\n\n${errorInfo?.componentStack || error.stack || ""}`;
    navigator.clipboard.writeText(text).then(() => {
      this.setState({ copied: true });
      setTimeout(() => this.setState({ copied: false }), 1500);
    });
  };

  render() {
    const { error, errorInfo, copied } = this.state;

    if (error) {
      return (
        <div className="error-boundary-container">
          <h2 className="error-boundary-title">An unexpected error occurred</h2>
          <div className="error-boundary-message">
            <b>Error:</b> {error.message}
          </div>
          <pre className="error-boundary-stack">{errorInfo?.componentStack || error.stack}</pre>
          <button className="error-boundary-copy-btn" onClick={this.handleCopy}>
            {copied ? "Copied!" : "Copy error"}
          </button>
          <span className="error-boundary-hint">If this happens repeatedly, please send the error to support.</span>
        </div>
      );
    }

    return this.props.children;
  }
}
